import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '@/hooks/useAppDispatch';
import { identityVerifyMagicLink, getActivePortalHomePath } from '@/store/identitySlice';
import { showApiError } from '@/utils/apiError';

export function IdentityVerifyPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      navigate('/identity/login', { replace: true });
      return;
    }
    void (async () => {
      try {
        const result = await dispatch(identityVerifyMagicLink(token)).unwrap();
        if ((result.availablePortals?.length ?? 0) > 1) {
          navigate('/identity/portals', { replace: true });
          return;
        }
        navigate(getActivePortalHomePath({
          identityId: result.identityId,
          identityUuid: result.identityUuid,
          email: result.email,
          activeProfileId: result.activeProfileId!,
          activePortalCode: result.activePortalCode!,
          organizationId: result.organizationId!,
          organizationName: result.organizationName,
          permissions: result.permissions ?? [],
          availablePortals: result.availablePortals ?? [],
        }), { replace: true });
      } catch (err) {
        showApiError(err, 'Link invalid or expired');
        navigate('/identity/login', { replace: true });
      }
    })();
  }, [dispatch, navigate, params]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary-600 border-t-transparent" />
    </div>
  );
}
